var _style, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle2, _circle3, _circle4, _circle5, _circle6, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitelabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2E3192;}\r\n\t.st1{fill:#29ABE2;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{fill:url(#SVGID_3_);}\r\n\t.st5{fill:url(#SVGID_4_);}\r\n\t.st6{fill:url(#SVGID_5_);}\r\n\t.st7{fill:url(#SVGID_6_);}\r\n\t.st8{fill:url(#SVGID_7_);}\r\n\t.st9{fill:url(#SVGID_8_);}\r\n\t.st10{fill:url(#SVGID_9_);}\r\n\t.st11{fill:url(#SVGID_10_);}\r\n\t.st12{fill:url(#SVGID_11_);}\r\n\t.st13{fill:url(#SVGID_12_);}\r\n\t.st14{fill:url(#SVGID_13_);}\r\n\t.st15{fill:url(#SVGID_14_);}\r\n\t.st16{fill:url(#SVGID_15_);}\r\n\t.st17{fill:url(#SVGID_16_);}\r\n\t.st18{fill:url(#SVGID_17_);}\r\n\t.st19{fill:url(#SVGID_18_);}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Comet icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 128,
    cy: 128,
    r: 128
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.3,105.6c0.3,1.6,2.4,2.5,4.5,2l6.5-1.4c2.2-0.4,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-6.5,1.4 C107.5,102.4,106,104.1,106.3,105.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.4,108.4c0.3,1.6,2.4,2.5,4.5,2l3.6-0.8c2.2-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-3.6,0.8 C94.6,105.1,93.1,106.8,93.4,108.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.2,90.3c0.3,1.6,2.4,2.5,4.5,2l3.6-0.8c2.1-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-3.6,0.8 C136.4,87.1,134.9,88.8,135.2,90.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.4,162.5c0.3,1.6,2.4,2.5,4.5,2l6.5-1.4c2.2-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-6.5,1.4 C141.6,159.2,140.1,160.9,140.4,162.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86,119.1c0.3,1.6,2.4,2.5,4.5,2l3.6-0.8c2.2-0.4,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-3.6,0.8 C87.1,115.9,85.6,117.5,86,119.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.7,160.9c0.3,1.6,2.4,2.5,4.5,2l3.6-0.8c2.2-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-3.6,0.8 C106.9,157.6,105.4,159.3,105.7,160.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.6,155.3c0.3,1.6,2.4,2.5,4.5,2l13.6-2.9c2.2-0.4,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-13.6,2.9 C90.7,152.1,89.3,153.8,89.6,155.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.7,158.1c0.3,1.6,2.4,2.5,4.5,2l3.6-0.8c2.2-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-3.6,0.8 C77.9,154.8,76.4,156.5,76.7,158.1z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 72.4,
    cy: 159,
    r: 2.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 21.3,
    cy: 151.2,
    r: 2.9
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 81.3,
    cy: 120.1,
    r: 2.9
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 130.8,
    cy: 91.3,
    r: 2.9
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 135.4,
    cy: 163.5,
    r: 2.9
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.3,135.2c0.3,1.6,2.4,2.5,4.5,2l13.6-2.9c2.2-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-13.6,2.9 C55.5,131.9,54,133.6,54.3,135.2z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.2,137.8c0.3,1.6,2.4,2.5,4.5,2l2.9-0.6c2.2-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-2.9,0.6 C43.3,134.5,41.8,136.2,42.2,137.8z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58,152.3c0.3,1.6,2.4,2.5,4.5,2l13.6-2.9c2.2-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-13.6,2.9 C59.1,149.1,57.6,150.8,58,152.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.1,155.1c0.3,1.6,2.4,2.5,4.5,2l3.6-0.8c2.2-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-3.6,0.8 C46.3,151.8,44.8,153.5,45.1,155.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.5,150.3c0.3,1.6,2.4,2.5,4.5,2l3.6-0.8c2.2-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-3.6,0.8 C26.7,147,25.2,148.7,25.5,150.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.4,147.5c0.3,1.6,2.4,2.5,4.5,2l13.6-2.9c2.2-0.4,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-13.6,2.9 C39.6,144.3,38.1,146,38.4,147.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.2884,
    y1: -73.9345,
    x2: 65.9984,
    y2: -73.9345,
    gradientTransform: "matrix(0.98 -0.21 -0.21 -0.98 98.8 95.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0071BC"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.1,159.1c0.3,1.6,2.4,2.5,4.5,2l14.4-3.1c2.1-0.4,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-14.4,3.1 C157.3,155.9,155.8,157.6,156.1,159.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.2984,
    y1: -2.4536,
    x2: 65.6984,
    y2: -2.4536,
    gradientTransform: "matrix(0.98 -0.21 -0.21 -0.98 98.8 95.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0071BC"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M148.1,87.6c0.3,1.6,2.4,2.5,4.5,2l7.2-1.5c2.2-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-7.2,1.5 C149.3,84.3,147.8,86,148.1,87.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.7484,
    y1: -11.1552,
    x2: 58.3484,
    y2: -11.1552,
    gradientTransform: "matrix(0.98 -0.21 -0.21 -0.98 98.8 95.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0071BC"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M122,102.1c0.3,1.6,2.4,2.5,4.5,2l28-6c2.1-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-28,6 C123.2,98.9,121.7,100.5,122,102.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.7784,
    y1: -64.9882,
    x2: 57.9883,
    y2: -64.9882,
    gradientTransform: "matrix(0.98 -0.21 -0.21 -0.98 98.8 95.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0071BC"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M118.6,158c0.3,1.6,2.4,2.5,4.5,2l42.3-9c2.2-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-42.3,9 C119.7,154.7,118.2,156.4,118.6,158z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.8916,
    y1: -20.27,
    x2: 50.9883,
    y2: -20.27,
    gradientTransform: "matrix(0.98 -0.21 -0.21 -0.98 98.8 95.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0071BC"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M98.8,116.4c0.3,1.6,2.4,2.5,4.5,2l45.8-9.8c2.1-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-45.8,9.8 C100,113.1,98.5,114.8,98.8,116.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.3684,
    y1: -56.0156,
    x2: 53.5884,
    y2: -56.0156,
    gradientTransform: "matrix(0.98 -0.21 -0.21 -0.98 98.8 95.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0071BC"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M112.4,150.1c0.3,1.6,2.4,2.5,4.5,2l42.3-9c2.2-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-42.3,9 C113.6,146.9,112.1,148.6,112.4,150.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -27.9316,
    y1: -29.3665,
    x2: 45.2284,
    y2: -29.3665,
    gradientTransform: "matrix(0.98 -0.21 -0.21 -0.98 98.8 95.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0071BC"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M77.2,130.3c0.3,1.6,2.4,2.5,4.5,2l63.7-13.5c2.2-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-63.7,13.5 C78.4,127.1,76.9,128.7,77.2,130.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -27.9316,
    y1: -46.9051,
    x2: 45.2284,
    y2: -46.9051,
    gradientTransform: "matrix(0.98 -0.21 -0.21 -0.98 98.8 95.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0071BC"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M80.9,147.5c0.3,1.6,2.4,2.5,4.5,2l63.7-13.5c2.1-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-63.7,13.5 C82,144.2,80.5,145.9,80.9,147.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -46.0616,
    y1: -38.1088,
    x2: 43.3284,
    y2: -38.1088,
    gradientTransform: "matrix(0.98 -0.21 -0.21 -0.98 98.8 95.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0071BC"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M61.3,142.7c0.3,1.6,2.4,2.5,4.5,2l79.6-16.9c2.2-0.4,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-79.6,17 C62.5,139.4,61,141.1,61.3,142.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.3084,
    y1: -73.9999,
    x2: 103.5484,
    y2: -73.9999,
    gradientTransform: "matrix(0.98 -0.21 -0.21 -0.98 98.8 95.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFFFE5"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M186.5,152.7c0.3,1.6,2.4,2.5,4.5,2l20.8-4.4c2.1-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-20.8,4.4 C187.6,149.4,186.1,151.1,186.5,152.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.3084,
    y1: -2.5045,
    x2: 103.5484,
    y2: -2.5045,
    gradientTransform: "matrix(0.98 -0.21 -0.21 -0.98 98.8 95.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFFFE5"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M171.6,82.6c0.3,1.6,2.4,2.5,4.5,2l20.8-4.4c2.1-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-20.8,4.4 C172.7,79.4,171.3,81,171.6,82.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.3384,
    y1: -11.4515,
    x2: 114.5184,
    y2: -11.4515,
    gradientTransform: "matrix(0.98 -0.21 -0.21 -0.98 98.8 95.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFFFE5"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M162.7,93.6c0.3,1.6,2.4,2.5,4.5,2l42.2-9c2.1-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2L166,90 C163.9,90.4,162.4,92.1,162.7,93.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.3784,
    y1: -65.0345,
    x2: 114.4784,
    y2: -65.0345,
    gradientTransform: "matrix(0.98 -0.21 -0.21 -0.98 98.8 95.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFFFE5"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M173.9,146.2c0.3,1.6,2.4,2.5,4.5,2l42.2-9c2.2-0.4,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-42.2,9 C175.1,143,173.6,144.6,173.9,146.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.1984,
    y1: -20.3811,
    x2: 123.6584,
    y2: -20.3811,
    gradientTransform: "matrix(0.98 -0.21 -0.21 -0.98 98.8 95.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFFFE5"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M155.6,104.3c0.3,1.6,2.4,2.5,4.5,2l60.1-12.8c2.1-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2L159,100.6 C156.8,101.1,155.3,102.7,155.6,104.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.3084,
    y1: -56.1254,
    x2: 120.5484,
    y2: -56.1254,
    gradientTransform: "matrix(0.98 -0.21 -0.21 -0.98 98.8 95.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFFFE5"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M166.1,138.7c0.3,1.6,2.4,2.5,4.5,2l54-11.5c2.1-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-54,11.5 C167.3,135.5,165.8,137.1,166.1,138.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.5484,
    y1: -29.3122,
    x2: 127.3084,
    y2: -29.3122,
    gradientTransform: "matrix(0.98 -0.21 -0.21 -0.98 98.8 95.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFFFE5"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M153.9,113.8c0.3,1.6,2.4,2.5,4.5,2l67.3-14.3c2.1-0.5,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-67.3,14.3 C155.1,110.6,153.6,112.3,153.9,113.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.5484,
    y1: -47.1868,
    x2: 127.3084,
    y2: -47.1868,
    gradientTransform: "matrix(0.98 -0.21 -0.21 -0.98 98.8 95.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFFFE5"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M157.7,131.3c0.3,1.6,2.4,2.5,4.5,2l67.3-14.3c2.2-0.4,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2L161,127.7 C158.8,128.1,157.3,129.8,157.7,131.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.7184,
    y1: -38.2839,
    x2: 129.1384,
    y2: -38.2839,
    gradientTransform: "matrix(0.98 -0.21 -0.21 -0.98 98.8 95.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFFFE5"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M154,123c0.3,1.6,2.4,2.5,4.5,2l70.8-15.1c2.1-0.4,3.6-2.1,3.3-3.7s-2.4-2.5-4.5-2l-70.8,15.1 C155.2,119.7,153.7,121.4,154,123z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitelabel);
export default __webpack_public_path__ + "static/media/whitelabel.763ee075d5c4c74eb3f2af541a303f57.svg";
export { ForwardRef as ReactComponent };